import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/logo.png'


const _withScopeId = n => (_pushScopeId("data-v-311e1df6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "loginBg" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "top" }, [
  /*#__PURE__*/_createElementVNode("a", {
    href: "https://www.xinnet.com",
    target: "_blank"
  }, [
    /*#__PURE__*/_createElementVNode("img", {
      class: "logo",
      src: _imports_0,
      width: "74",
      height: "20"
    })
  ]),
  /*#__PURE__*/_createElementVNode("a", {
    class: "link",
    style: {"color":"rgba(0,0,0,0.85)"},
    href: "https://www.xinnet.com/service/cjwt/idc/guanli/1587.html",
    target: "_blank"
  }, " 帮助中心 ")
], -1))
const _hoisted_3 = { class: "loginCon" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "left" }, null, -1))
const _hoisted_5 = { class: "right" }
const _hoisted_6 = { class: "form" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "tit" }, "欢迎登录", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "txt" }, "请使用站点的 FTP 账号，密码登录", -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "用户名或密码错误", -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "bot" }, [
  /*#__PURE__*/_createElementVNode("p", null, "Copyright © 1993-2024 北京新网数码信息技术有限公司 版权所有")
], -1))

import { reactive, ref } from 'vue'
import { LOGIN } from '@/api/main'
import { useRouter } from 'vue-router'

interface FormState {
  hostName: string
  password: string
}


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const router = useRouter()
const loading = ref(false)
const msgError = ref(false)
const formState = reactive<FormState>({
  hostName: '',
  password: ''
})
const onFinish = (values: any) => {
  console.log('Success:', values)
}

const onFinishFailed = (errorInfo: any) => {
  console.log('Failed:', errorInfo)
}

const initTencentVerify = () => {
  try {
    // 生成一个验证码对象
    // CaptchaAppId：登录验证码控制台，从【验证管理】页面进行查看。如果未创建过验证，请先新建验证。注意：不可使用客户端类型为小程序的CaptchaAppId，会导致数据统计错误。
    //callback：定义的回调函数
    var captcha1 = new TencentCaptcha('2066116126', (res) => {
      // domainYkjExport(getParams())
      // 执行操作，需要传递res.randstr, res.ticket到后台请求接口进行滑块票据验证
      if (res.randstr.length && res.ticket.length) {
        loading.value = true
        let PWD = Xinnet.util.aesEncrypt(formState.password, '_iO7A3WcloTHiVrU')
        const param = new FormData()
        param.append('hostName', formState.hostName)
        param.append('password', PWD)
        param.append('captchaRand', res.randstr)
        param.append('captchaTicket', res.ticket)
        LOGIN(param).then((res:any) => {
          try {
            if(res.code == '403') {
              msgError.value = true
            } else {
              const route = window.location.hash.split('?r=')[1]
              router.push(route)
              msgError.value = false
            }
          } catch (e) { 
            router.push('/')
          }
        }).finally(() => {
          setTimeout(() => {
            loading.value = false
          }, 1000)
        })
      }
    })
    // 调用方法，显示验证码
    captcha1.show()
  } catch (error) {
    // 加载异常，调用验证码js加载错误处理函数
    console.log('生成验证码异常')
  }
}

return (_ctx: any,_cache: any) => {
  const _component_xn_alert = _resolveComponent("xn-alert")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_input_password = _resolveComponent("a-input-password")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_layout_content = _resolveComponent("a-layout-content")!
  const _component_a_layout = _resolveComponent("a-layout")!

  return (_openBlock(), _createBlock(_component_a_layout, { style: {"background":"#F7F8FA","height":"100vh"} }, {
    default: _withCtx(() => [
      _createVNode(_component_a_layout_content, null, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _hoisted_2,
            _createElementVNode("div", _hoisted_3, [
              _hoisted_4,
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _hoisted_7,
                  _hoisted_8,
                  _createVNode(_component_a_form, {
                    model: formState,
                    name: "basic",
                    "wrapper-col": { span: 24 },
                    autocomplete: "off",
                    onFinish: onFinish,
                    onFinishFailed: onFinishFailed
                  }, {
                    default: _withCtx(() => [
                      (msgError.value)
                        ? (_openBlock(), _createBlock(_component_xn_alert, {
                            key: 0,
                            class: "s3-mt s5-mb errormsg",
                            type: "danger",
                            title: "",
                            mode: "inline",
                            closeable: ""
                          }, {
                            default: _withCtx(() => [
                              _hoisted_9
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true),
                      _createVNode(_component_a_form_item, {
                        label: "",
                        name: "hostName",
                        rules: [{ required: true, message: '请输入用户名' }]
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_input, {
                            style: {"height":"40px"},
                            placeholder: "请输入您的主机用户名",
                            value: formState.hostName,
                            "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((formState.hostName) = $event))
                          }, null, 8, ["value"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_a_form_item, {
                        label: "",
                        name: "password",
                        rules: [{ required: true, message: '请输入密码' }]
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_input_password, {
                            style: {"height":"40px"},
                            placeholder: "请输入您的主机密码",
                            value: formState.password,
                            "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((formState.password) = $event))
                          }, null, 8, ["value"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_a_form_item, { "wrapper-col": { span: 24 } }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_button, {
                            block: "",
                            type: "primary",
                            "html-type": "submit",
                            loading: loading.value,
                            onClick: initTencentVerify,
                            class: "loginbtn xn-operation",
                            style: {"box-shadow":"none"}
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(" 登 录 ")
                            ]),
                            _: 1
                          }, 8, ["loading"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["model"])
                ])
              ])
            ]),
            _hoisted_10
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})